import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import { Icon } from '../icon/icon';

require('../../../../icons/upload.svg');
require('../../../../icons/paperclip.svg');
require('../../../../icons/close.svg');

@Component({
  template: require('./upload.html'),
  name: 'wc-upload',
  components : {
    'wc-icon':Icon
  }
})
export class Upload extends Vue {

  @Prop({
    default: 'Upload'
  })
  text: string;

  @Prop({
    default: 'upload'
  })
  iconName: string;

  @Prop()
  loading: boolean;

  @Prop()
  multiple: boolean;

  @Prop()
  accept: string;

  @Prop()
  showFileList: boolean;

  @Prop()
  clearOnFileChange: boolean;

  @Prop()
  onChange: (fileList: FileList) => void;
  
  @Prop({
    default: false
  })
  disabled: boolean;

  fileList: Array<File> = [];

  uploadClick() {
    (this.$refs.fileElement as HTMLInputElement).click();
  }

  fileChange(event) {
    if (this.clearOnFileChange) {
      if (!this.multiple) {
        this.fileList = [];
      }
      // Clone file list
      Array.prototype.push.apply( this.fileList, event.target.files );
    } else {
      this.fileList = event.target.files;
    }
    if (this.onChange) {
      this.onChange.call(this, this.fileList);
    }
    if (this.clearOnFileChange) {
      // Clear file list 
      (this.$refs.fileElement as HTMLInputElement).value = "";
    }
  }
}



// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-ui/components/upload/upload.ts